import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ChannelsandoperationsService } from '../../../../services/channelsandoperations.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-canal',
  templateUrl: './canal.component.html',
  styleUrls: ['./canal.component.scss'],
})
export class CanalComponent implements OnInit {
  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 2000,
    });
  }
  channelCreateForm = this.fb.group({
    nombre: [
      '',
      [
        Validators.required,
        Validators.maxLength(30),
      ],
    ],
    id_usuarios_creador: [sessionStorage.getItem('id_usuario')],
  });
  constructor(
    public dialogRef: MatDialogRef<CanalComponent>,
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public canalService: ChannelsandoperationsService,
    public _snackBar: MatSnackBar
  ) {}

  ngOnInit(): void {}

  onSubmit() {
    this.channelCreateForm.controls.id_usuarios_creador.setValue(
      sessionStorage.getItem('id_usuario')
    );
    this.channelCreateForm.value.borrado = 0;
    this.canalService.createChannel(this.channelCreateForm.value).subscribe(
      (res) => {
        console.log("Respuesta",res);
        this.openSnackBar('Canal creado con éxito.', 'X');
        this.dialogRef.close(true);
      },
      (err) => {
        console.log(err.error.payload)
        this.openSnackBar(err.error.payload,'x')
      }
    );
  }
}
